import { render, staticRenderFns } from "./SendMail.vue?vue&type=template&id=874a830c"
import script from "./SendMail.vue?vue&type=script&lang=js"
export * from "./SendMail.vue?vue&type=script&lang=js"
import style0 from "./SendMail.vue?vue&type=style&index=0&id=874a830c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports